import { Stack } from '@mui/system';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from '../../../../hooks';
import { getGenerationId } from '../../../../store/GenerationSlice';
import { AppDispatch, RootState } from '../../../../store/store';
import { Mode } from '../../../../types/common';
import { BaseForm, FormInput, FormSelect } from '../../../UI';

const INIT_INPUT = {
  title: '',
  style: 'informal',
};

const STYLE = [
  {
    id: 1,
    value: 'informal',
    name: 'Неформальный',
  },
  {
    id: 2,
    value: 'formal',
    name: 'Формальный',
  },
];

const VALIDATE_FIELDS = ['title', 'style'];

interface IReviewFormProps {}

const ReviewForm: React.FC<IReviewFormProps> = () => {
  const { input, error, handleChange, submit, resetForm, tags, handleAddTag, handleDeleteTag, handlePressKey } =
    useForm(INIT_INPUT, handleSubmit, VALIDATE_FIELDS);
  const { isGenerationLoading, isHistoryLoading } = useSelector((state: RootState) => state.generation);
  const dispatch = useDispatch<AppDispatch>();

  function handleSubmit() {
    dispatch(getGenerationId({ ...input, tags, mode: Mode.Review }));
  }

  return (
    <BaseForm onSubmit={submit} onReset={resetForm}>
      <Stack gap={'20px'}>
        <FormInput
          onChange={handleChange}
          error={error.title || ''}
          name={'title'}
          value={input.title || ''}
          placeholder={'Например, шерстяной свитер'}
          label={'Название товара'}
          maxLength={350}
          required
        />

        <FormSelect
          onChange={handleChange}
          error={error.style || ''}
          name={'style'}
          value={input.style || ''}
          placeholder={'Выберите стиль'}
          label={'Стиль текста'}
          options={STYLE}
        />

        <FormInput
          onChange={handleChange}
          onAddTag={handleAddTag}
          onDeleteTag={handleDeleteTag}
          onKeyPress={handlePressKey}
          name={'tags'}
          value={input.tags || ''}
          placeholder={'Например, свитер в подарок'}
          label={'Ключевые слова'}
          tags={tags}
          disabled={isGenerationLoading || isHistoryLoading}
          maxLength={30}
        />
      </Stack>
    </BaseForm>
  );
};

export default ReviewForm;
